import React from 'react';
import { notification } from 'antd';
import { EnumNotificationPlacement } from './enums/notificationPlacement.enum';

const PreserveBreakLine = ({ description }) => <div style={{ whiteSpace: 'pre-wrap' }}>{description}</div>;

function showSuccess({ title, description, duration, placement }) {
  notification.success({
    message: title || 'Sucesso',
    description: <PreserveBreakLine description={description} />,
    duration: duration || 0,
    placement: placement || EnumNotificationPlacement.TopRight,
  });
}

function showInfo({ title, description, duration, placement }) {
  notification.info({
    message: title || 'Informação',
    description: <PreserveBreakLine description={description} />,
    duration: duration || 0,
    placement: placement || EnumNotificationPlacement.TopRight,
  });
}

function showWarning({ title, description, duration, placement }) {
  notification.warning({
    message: title || 'Alerta',
    description: <PreserveBreakLine description={description} />,
    duration: duration || 0,
    placement: placement || EnumNotificationPlacement.TopRight,
  });
}

function showError({ title, description, duration, placement }) {
  notification.error({
    message: title || 'Erro',
    description: <PreserveBreakLine description={description} />,
    duration: duration || 0,
    placement: placement || EnumNotificationPlacement.TopRight,
  });
}

function showCustomNotification({ title, description, duration, placement, icon }) {
  notification.open({
    message: title,
    description: <PreserveBreakLine description={description} />,
    icon: icon || '',
    duration: duration || 0,
    placement: placement || EnumNotificationPlacement.TopRight,
  });
}

export default { showSuccess, showInfo, showWarning, showError, showCustomNotification };
